import React, { Fragment, useState, useEffect, useRef } from "react";
import { translate } from "../Services/translation";
import ProductUnitChangeModal from "./ProductUnitChangeModal/index";

const ProductUnitSelector = ({
    unitOptions,
    defaultUnit,
    quantityFieldId,
    anonymousUser,
    loginPageUrl,
    inProductPage,
    onClick,
    onRemove,
    onQuantityClick,
    onSuccess,
    productsInCart,
    getQuantity,
    getOrderRowId,
}) => {
    const inputRef = useRef();
    const [selectedUnit, setSelectedUnit] = useState(defaultUnit);
    const [newSelectedUnit, setNewSelectedUnit] = useState(defaultUnit);
    const [hintQuantityMessage, setHintQuantityMessage] = useState(false);
    const [productUnitChangeModal, setProductUnitChangeModal] = useState(false);
    let selectedItem = unitOptions.find((x) => x.unitId == selectedUnit);

    if (!selectedItem && unitOptions.length) {
        selectedItem = unitOptions[0];
    }

    const isProductPage = inProductPage === "true";

    const schema = "http://schema.org";
    let quantityStep =
        selectedItem && selectedItem.categoryPalletSize > 0
            ? selectedItem.categoryPalletSize
            : 1;

    let selectedItemQuantity = getQuantity(
        productsInCart,
        selectedItem.articleNumber
    );
    let orderRowSystemId = getOrderRowId(
        productsInCart,
        selectedItem.articleNumber
    );

    useEffect(() => {
        if (productsInCart.length > 0) {
            const unit = unitOptions.find(
                (u) => u.articleNumber === productsInCart[0].articleNumber
            ).unitId;
            setSelectedUnit(unit);
        }
    }, []);

    useEffect(() => {
        if (!inputRef || !inputRef.current) return;

        if (
            document.activeElement !== inputRef.current &&
            selectedItemQuantity !== 0
        ) {
            const newQuantity = getProductQuantity(selectedItemQuantity);
            inputRef.current.value = newQuantity;
        }
    });

    const onChangeUnitSelector = (e) => {
        const { value } = e.currentTarget;

        if (productsInCart.length === 0) {
            setSelectedUnit(value);
            return;
        }
        if (selectedUnit === value) return;

        setNewSelectedUnit(value);
        setProductUnitChangeModal(true);
    };

    const addToCart = () => {
        const quantityStep =
            selectedItem.categoryPalletSize > 0
                ? selectedItem.categoryPalletSize
                : 1;
        if (quantityStep > 1) {
            setHintQuantityMessage(true);

            setTimeout(() => {
                setHintQuantityMessage(false);
            }, 2500);
        }
        onClick(
            selectedItem.articleNumber,
            quantityStep,
            selectedItem.categoryPalletSize
        );
        onSuccess();
    };

    const updateQuantity = (quantity = selectedItemQuantity) => {
        onQuantityClick(orderRowSystemId, quantity);
        onSuccess();
    };

    const closeModal = () => setProductUnitChangeModal(false);

    const handlePucmCancel = () => closeModal();

    const handlePucmConfirm = () => {
        setSelectedUnit(newSelectedUnit);
        onRemove(selectedItem.articleNumber);
        updateQuantity(0);
        onSuccess();
        closeModal();
    };

    const add = () => {
        if (selectedItem.categoryPalletSize > 0) {
            setHintQuantityMessage(true);
            setTimeout(() => {
                setHintQuantityMessage(false);
            }, 2500);
        }
        selectedItemQuantity = selectedItemQuantity + quantityStep;
        updateQuantity();
    };

    const subtract = () => {
        if (selectedItemQuantity > 0) {
            selectedItemQuantity = selectedItemQuantity - quantityStep;
            updateQuantity();
        }
    };

    const changeInput = (value) => {
        if (value > 999) {
            value = 999;
        }

        selectedItemQuantity = getProductQuantity(value);
        updateQuantity();
    };

    const handleKeyPress = (e) => {
        let { key, target } = e;
        let { value } = target;

        if (key === "Enter") changeInput(value);
    };

    const onInputBlur = (e) => {
        let { value } = e.target;

        changeInput(value);
    };

    const getProductPriceListing = () => (
        <>
            <div
                className="product__price product__price-listing"
                itemProp="offers"
                itemScope
                itemType={`${schema}/Offer`}
            >
                {selectedItem && (
                    <>
                        <div
                            itemProp="offers"
                            itemScope
                            itemType={`${schema}/Offer`}
                        >
                            {(selectedItem && selectedItem.campaignPrice) && (
                            <span className={`product__price ${selectedItem.campaignPrice && "product__campaign-price"}`}>
                                {selectedItem.campaignPrice}{selectedItem.unit}
                            </span>
                            )}

                            {(selectedItem && !selectedItem.campaignPrice) && (
                            <span className={`product__price`}>
                                {!anonymousUser && selectedItem.price + selectedItem.unit}
                            </span>
                            )}

                        </div>
                        <link
                            itemProp="availability"
                            href={`${schema}/${
                                selectedItem.isInStock ? "In" : "Out"
                            }Stock`}
                        />
                    </>
                )}
                <link itemProp="url" href="@Model.Url" />
            </div>

            {getProductComparisonPrice()}
            
            {selectedItem && selectedItem.campaignPrice && (
                <span className="product__old-price">
                    {translate("product.price.regular")} {selectedItem.price}
                </span>
                )}
        </>
    );

    const getProductStockSection = () => (
        <>
            {selectedItem && (
                <div
                    className={
                        (isProductPage
                            ? "product-detail__stock-container "
                            : " ") +
                        "stock-indicator__container stock-indicator--" +
                        selectedItem.stockBalanceColor
                    }
                >
                    <div className={`${isProductPage ? "product-detail__stock-text" : ""} stock-indicator__text `}>
                        {selectedItem.stockBalanceText}
                    </div>
                </div>
            )}
        </>
    );

    const getProductComparisonPrice = (comparisonPrice = 20) => (
        <>
            {(selectedItem && selectedItem.campaignPrice) && (
                <div className="product__price-comparison">
                    {selectedItem && selectedItem.comparisonPriceString !== '' && (
                        `Jmf.pris ${selectedItem.comparisonPriceString}`
                    )}
                </div>
            )}

            {(selectedItem && !selectedItem.campaignPrice) && (
                <div className={`product__price-comparison`}>
                    {!anonymousUser && selectedItem && selectedItem.comparisonPriceString !== '' && (
                        `Jmf.pris ${selectedItem.comparisonPriceString}`
                    )}
                </div>
            )}
        </>
    );

    const getProductQuantity = (value) => {
        if (selectedItem.categoryPalletSize > 0) {
            let closestAmount = value;
            const leftOvers = value % selectedItem.categoryPalletSize;
            if (
                leftOvers !== 0 &&
                leftOvers >= selectedItem.categoryPalletSize / 2
            ) {
                closestAmount =
                    Math.ceil(value / selectedItem.categoryPalletSize) *
                    selectedItem.categoryPalletSize;
            } else {
                closestAmount =
                    Math.floor(value / selectedItem.categoryPalletSize) *
                    selectedItem.categoryPalletSize;
            }
            if (closestAmount === 0) {
                closestAmount = selectedItem.categoryPalletSize;
            }

            if (value != closestAmount) {
                setHintQuantityMessage(true);
                setTimeout(() => {
                    setHintQuantityMessage(false);
                }, 2500);
            }
            return closestAmount;
        } else {
            return value;
        }
    };

    return (
        <>
            {productUnitChangeModal && (
                <ProductUnitChangeModal
                    onCancel={handlePucmCancel}
                    onConfirm={handlePucmConfirm}
                />
            )}
            <div>
                {isProductPage && getProductStockSection()}
                <div
                    className={`product__price-stock-container ${
                        !isProductPage && "isGrid"
                    } ${anonymousUser && "anonymousUser"}`}
                >
                    {getProductPriceListing()}
                    {!isProductPage && getProductStockSection()}                    
                </div>
                <div className="unit-selector">
                    <div className="unit-selector__wrapper">
                        <div className="unit-selector__select-container">
                            {unitOptions.length > 1 ? (
                                <select
                                    value={selectedUnit}
                                    className="product__buy-unit form__select"
                                    onChange={onChangeUnitSelector}
                                >
                                    {unitOptions.map(
                                        ({ id, unitId, unitDescription }) => (
                                            <option key={id} value={unitId}>
                                                {unitDescription}
                                            </option>
                                        )
                                    )}
                                </select>
                            ) : (
                                <span className="unit-selector__single-unit">
                                    {unitOptions[0].unitDescription}
                                </span>
                            )}
                        </div>
                        {!anonymousUser ? (
                            <div className="unit-selector__quantity-wrapper">
                                <button
                                    className={`unit-selector__quantity-button product__quantity-button--buy ${
                                        selectedItem.isInStock
                                            ? ""
                                            : "unit-selector__quantity-button--disabled"
                                    } ${
                                        selectedItemQuantity === 0
                                            ? "visible"
                                            : "hidden"
                                    }`}
                                    onClick={() => addToCart()}
                                >
                                    +
                                </button>
                                <div
                                    className={`unit-selector__notice ${
                                        hintQuantityMessage
                                            ? "  unit-selector__notice--visible"
                                            : ""
                                    }`}
                                >
                                    {translate("product.notice.palletsize")}
                                </div>

                                <div
                                    className={`unit-selector__quantity-container ${
                                        selectedItemQuantity !== 0
                                            ? "visible"
                                            : "hidden"
                                    }`}
                                >
                                    <button
                                        className="unit-selector__quantity-button subtract"
                                        onClick={() => subtract()}
                                    >
                                        -
                                    </button>

                                    <input
                                        id={quantityFieldId}
                                        ref={inputRef}
                                        type="number"
                                        data-buy-quantity-input
                                        defaultValue={selectedItemQuantity}
                                        onBlur={(e) => onInputBlur(e)}
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        inputMode="decimal"
                                        step={selectedItem.categoryPalletSize}
                                        maxLength="3"
                                        className="unit-selector__buy-quantity form__input"
                                    />
                                    <button
                                        className="unit-selector__quantity-button add"
                                        onClick={() => add()}
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <a
                                href={loginPageUrl}
                                className="button buy-button product__buy-button btn btn--salad btn__block"
                            >
                                {translate("general.loginorregister")}
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProductUnitSelector;
